import { useState, useContext, useEffect } from "react";
import React from "react";

import AuthContext from "../../context/userAuth.context";
import Popup from "reactjs-popup";
import { useHistory } from "react-router-dom";
import CharacterContext from "../../context/CharacterContext";
import { Tooltip } from "react-tippy";
import AdminProps from "../../Administration/AdminProps";
import AgencyPanel from "../../Administration/AgencyPanel";
import Swal from "sweetalert2";
import { useAIAccess, openAIStudio } from "../../AIStudio/AIAccess";

export const Navlink = (props) => {
  let history = useHistory();

  const [Pop, setPop] = useState({ show: false, Name: null });

  const { setCharPopup, setredirect } = useContext(CharacterContext);

  const { DivName, setDivName, Role, setTip, Access, getLink } = useContext(AuthContext);
  const [AdminPanelPopup, setAdminPanelPopup] = useState(false);
  const [AgencyPanelPop, setAgencyPanelPop] = useState(false);
  // AI Studio (id 10): shown, locked or hidden per customer (Admin Panel > AI Studio access).
  const aiAccess = useAIAccess();
  const premium = (lmc) =>
    ((Access === "FE" || Access === "US1") && lmc.id === 9) || (lmc.id === 10 && aiAccess.locked);

  const Path = history.location.pathname;

  const [leftMenuContent, setleftMenuContent] = useState([
    {
      id: 1,
      icon: "home",
      navText: "Dashboard",
      tipText: "Starts From Here",
      type: "",
      activeClass: ["navBarActive", ""],
    },
    {
      id: 10,
      icon: "auto_awesome",
      navText: "AI Studio",
      tipText: "Generate a template <br/> from a few words",
      type: "",
      isNew: true,
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 2,
      icon: "auto_awesome_mosaic",
      navText: "Templates",
      tipText: "Our ready made <br/> Professional templates",
      type: "",
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 3,
      icon: "manage_accounts",
      type: "popup",
      tipText: "Build your own Character",
      navText: "Build Character",
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 4,
      icon: "cloud",
      tipText: "All of Your saved <br/> Projects here",
      navText: "My Projects",
      type: "",
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 5,
      icon: "add",
      tipText: "Create From Scratch",
      navText: "Create",
      type: "",
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 6,
      icon: "videocam",
      tipText: "Your rendered videos",
      navText: "My Videos",
      type: "",
      activeClass: ["", "navIconHidden"],
    },
    {
      id: 7,
      icon: "shopping_cart",
      tipText: "My Purchases",
      navText: "My Purchases",
      type: "",
      activeClass: ["", "navIconHidden"],
    },
  ]);

  useEffect(() => {
    if (Path.toLowerCase() !== "/dashboard") {
      setleftMenuContent(
        leftMenuContent.filter((item) => item.navText !== "Build Character")
      );
    }
    if (Role.toLowerCase() == "admin") {
      let array = Array.from(leftMenuContent);
      let found = false;
      for (let i = 0; i < array.length; i++) {
        if (array[i].id == 6) {
          found = true;
        }
      }
      if (!found) {
        setleftMenuContent(
          leftMenuContent.concat({
            id: 8,
            icon: "admin_panel_settings",
            tipText: "Access Admin Panel",
            navText: "Admin Panel",
            type: "popup",
            activeClass: ["", "navIconHidden"],
          })
        );
      }
    }



    // if (Access === "US2") {
    // Admins: "Admin Panel" is added here. The check above never added it (My Videos has id 6, and
    // this call replaces the list anyway). Everyone else gets exactly the same menu as before.
    const adminItem = String(Role || "").toLowerCase() === "admin"
      ? [{
        id: 8,
        icon: "admin_panel_settings",
        tipText: "Access Admin Panel",
        navText: "Admin Panel",
        type: "popup",
        activeClass: ["", "navIconHidden"],
      }]
      : [];
    // Built from the list without the Admin / Agency items, so running again (page change, hot reload)
    // never adds them twice.
    setleftMenuContent(
      leftMenuContent.filter((item) => item.id !== 8 && item.id !== 9).concat(adminItem, {
        id: 9,
        icon: "manage_accounts",
        tipText: "Access Agency Panel",
        navText: "Agency Panel",
        type: "popup",
        activeClass: ["", "navIconHidden"],
      })

    );
    // }

  }, [Path]);

  const ActivateDivs = (params) => {
    let url = window.location.href.split("/");
    let baseUrl = url[0] + "//" + url[2];

    if (history.location.pathname != "/dashboard") {
      if (params == "Build Character") {
        localStorage.setItem("DivName", JSON.stringify("Dashboard"));

        localStorage.setItem("CharPopup", true);

      } else {

        localStorage.setItem("DivName", JSON.stringify(params));
      }
      window.open(baseUrl, "_blank");
    }
    setDivName(params);
  };

  const Poper = (params, lmc, activated) => {

    if (params) {
      ActivateDivs(lmc.navText);
      setPop({ show: false, Name: null });
    } else {
      if (lmc.navText == "Build Character") {

        if (setredirect && setCharPopup) {

          setredirect({ path: activated, status: true });
          setCharPopup(true);
        }
        else {
          ActivateDivs(lmc.navText);
        }
        setDivName("Dashboard");
      } else if (lmc.navText == "Agency Panel") {
        //alert("")
        //setAgencyPanelPop(true);
        ActivateDivs("Agency");
        setDivName("Agency");
      } else if (lmc.navText == "My Purchases") {
        //alert("")
        //setAgencyPanelPop(true);
        setDivName("Purchases");
      } else {
        setPop({ show: true, Name: lmc.navText });
        setAdminPanelPopup(true);
      }
    }
  };

  return (
    <>
      {leftMenuContent.filter((lmc) => lmc.id !== 10 || aiAccess.show).map((lmc, index) => (
        <React.Fragment key={index}>
          <div key={index} style={{ display: "flex" }}>
            {lmc.navText === DivName && <div className="sideActiveMenu" />}

            <div key={index} className="navlink">
              <Tooltip
                title={lmc.tipText}
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                position="right-end"
              >
                <div
                  onClick={() => {
                    if ((Access === "FE" || Access === "US1") && lmc.id === 9) {
                      Swal.fire({
                        title: "Upgrade Required",
                        html: `You have not purchased this upgrade yet. Please <a href="https://toons.ai/l/agency/" target='_blank'>upgrade</a> to unlock all features.`,
                        icon: "info",
                        cancelButtonColor: "#d33",
                        backdrop: null,
                      });
                      return;
                    } else if (lmc.id === 10 && (aiAccess.locked || aiAccess.studioUrl)) {
                      // Locked: upgrade message. New app address set: opens the new app.
                      openAIStudio(aiAccess);
                      return;
                    } else {
                      lmc.type !== "popup"
                        ? Poper(true, lmc, DivName)
                        : Poper(false, lmc, DivName);
                    }

                  }}
                  className={
                    "navLinkInisder transitionStyleNavLink " +
                    (DivName === lmc.navText ? "navBarActive" : "")
                  }
                  style={{ position: "relative" }}
                >
                  {premium(lmc) ? null : <div
                    className={
                      "navIcon " +
                      (DivName === lmc.navText ? "" : "navIconHidden")
                    }
                  >
                    <div className="navIconStyle">
                      <span className="material-icons-outlined">
                        {lmc.icon}
                      </span>
                    </div>
                  </div>}
                  <div className="navLinkText">{lmc.navText}</div>
                  {lmc.isNew && DivName !== lmc.navText && <span className="ais-nav-new">NEW</span>}
                  {premium(lmc) && (
                    <img
                      className="iconUS"
                      src="../AppIcons/IconsAll/PremiumIcon.svg"
                      style={{
                        position: "absolute",
                        width: "20px",
                        height: "20px",
                        left: "6px",
                        top: "1px",
                        zIndex: "1",
                      }}
                      alt="" />)}
                </div>
              </Tooltip>
            </div>
          </div>

          {Pop.Name === "Admin Panel" && lmc.id === 8 && (
            <AdminProps
              AdminPanelPopup={AdminPanelPopup}
              setAdminPanelPopup={setAdminPanelPopup}
            />
          )}
          {/* {AgencyPanelPop && (
            <AgencyPanel
              AgencyPanelPop={AgencyPanelPop}
              setAgencyPanelPop={setAgencyPanelPop}
            ></AgencyPanel>
          )} */}
        </React.Fragment>
      ))}
    </>
  );
};
export default Navlink;
